import * as React from 'react';
import { Datagrid, DateField, ListProps, TextField, } from 'react-admin';

export const LiveTrainingMessageDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="live-trainings-message-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="content" label="CONTENT"/>
			<DateField source="date" label="DATE"/>
		</Datagrid>
	);
};
